import type { PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables } from './__generated__/PageOwnershipByLineWithCollaboratorsDropdownContentQuery.graphql.ts';

// GraphQL Int is signed 32-bit; retain the existing request limit for all collaborators.
const MAX_GRAPHQL_INT = 2_147_483_647;

/**
 * Share variables across SSR preloading, the byline, and the dropdown to reuse the cached query.
 * The page's contentId maps to the GraphQL id argument; the other inputs pass through unchanged.
 */
export const getContentCollaboratorsQueryVariables = ({
	cloudId,
	contentId,
	spaceKey,
}: {
	cloudId: string;
	contentId: string;
	spaceKey: string;
}): PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables => ({
	cloudId,
	id: contentId,
	spaceKey,
	first: MAX_GRAPHQL_INT,
});
